import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import Link from 'flarum/common/components/Link';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import BolillaWidget from '../bolilla/BolillaWidget';
import MatchRatingComponent from '../match-rating/MatchRatingComponent';
import JokoakNavbar from './JokoakNavbar';
import NagusiBackNav from '../common/NagusiBackNav';
import UserMatchLineupWidget from '../lineup/UserMatchLineupWidget';
import SelectMatchModal from './SelectMatchModal';
const dayjs = window.dayjs;
export default class AurreraJokoakPage extends Page {
  constructor() {
    super(...arguments);
    _defineProperty(this, "loading", true);
    _defineProperty(this, "matches", []);
    _defineProperty(this, "seasons", []);
    _defineProperty(this, "currentSeasonName", '2025/2026');
    _defineProperty(this, "loadingMatchDetails", false);
    _defineProperty(this, "resizeHandler", null);
    // Game state tracking
    _defineProperty(this, "activeGame", 'none');
    _defineProperty(this, "activeMatchForGame", null);
  }
  // Currently selected match to vote/rate on

  oninit(vnode) {
    super.oninit(vnode);
    this.loadAllData();
    this.resizeHandler = () => m.redraw();
    window.addEventListener('resize', this.resizeHandler);
  }
  onremove(vnode) {
    if (this.resizeHandler) {
      window.removeEventListener('resize', this.resizeHandler);
    }
    super.onremove(vnode);
  }
  isMobile() {
    return window.innerWidth < 768;
  }
  loadAllData() {
    this.loading = true;
    m.redraw();
    const promises = [app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/nagusi/match-ratings/matches?include=season,userMatchLineups,competition&active_games=1'
    }), app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/nagusi/match-ratings/seasons'
    })];
    Promise.all(promises).then(responses => {
      // Push matches
      this.matches = app.store.pushPayload(responses[0]) || [];

      // Push seasons
      this.seasons = app.store.pushPayload(responses[1]) || [];
      if (this.seasons.length > 0) {
        const sortedSeasons = [...this.seasons].filter(s => s.name().replace(/\//g, '-') >= '2025-2026').sort((a, b) => b.name().localeCompare(a.name()));
        this.currentSeasonName = sortedSeasons.length > 0 ? sortedSeasons[0].name() : '2026-2027';
      }
      this.loading = false;
      m.redraw();
    }).catch(error => {
      console.error('Error loading Aurrera Jokoak data:', error);
      this.loading = false;
      m.redraw();
    });
  }
  selectMatch(match) {
    const hasLineupsWithUsers = match.userMatchLineups() && (match.userMatchLineups().length === 0 || match.userMatchLineups().every(l => l.user()));
    if (hasLineupsWithUsers && match.players() && match.players().length > 0) {
      this.activeMatchForGame = match;
      m.redraw();
      return;
    }
    this.loadingMatchDetails = true;
    this.activeMatchForGame = match;
    m.redraw();
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/nagusi/match-ratings/matches/' + match.id() + '?include=players,votes,votes.user,votes.player,bolillaVotes,bolillaVotes.user,userMatchLineups,userMatchLineups.user,season,competition'
    }).then(response => {
      app.store.pushPayload(response);
      this.activeMatchForGame = app.store.getById('nagusi_matches', match.id());
      this.loadingMatchDetails = false;
      m.redraw();
    }).catch(error => {
      console.error('Error loading match details:', error);
      this.loadingMatchDetails = false;
      m.redraw();
    });
  }

  // Returns matches open for predictions
  getBolillaMatches() {
    return this.matches.filter(match => {
      const comp = typeof match.competition === 'function' ? match.competition() : null;
      if (comp && comp.allowsBolilla && comp.allowsBolilla() === false && comp.allowsLineup && comp.allowsLineup() === false) {
        return false;
      }
      const matchDate = match.matchDate();
      if (!matchDate) return false;
      const deadline = dayjs(matchDate).subtract(2, 'hours');
      return dayjs().isBefore(deadline);
    }).sort((a, b) => new Date(a.matchDate()).getTime() - new Date(b.matchDate()).getTime());
  }

  // Returns matches open for player ratings
  getRatingMatches() {
    return this.matches.filter(match => {
      const comp = typeof match.competition === 'function' ? match.competition() : null;
      if (comp && comp.allowsRatings && comp.allowsRatings() === false) {
        return false;
      }
      const matchDate = match.matchDate();
      if (!matchDate) return false;
      const now = dayjs();
      const startsAt = dayjs(matchDate);
      const endsAt = startsAt.add(3, 'days');
      return now.isAfter(startsAt) && now.isBefore(endsAt);
    }).sort((a, b) => new Date(b.matchDate()).getTime() - new Date(a.matchDate()).getTime());
  }
  renderMatchSelector(matches, noMatchesLabel, colorClass) {
    if (matches.length === 0) {
      return m("div", {
        style: {
          textAlign: 'center',
          color: '#a3a9b1',
          padding: '40px 10px',
          fontStyle: 'italic',
          fontSize: '1.1em'
        }
      }, noMatchesLabel);
    }
    const isMobile = this.isMobile();
    const selectedMatchLabel = this.activeMatchForGame ? isMobile ? this.activeMatchForGame.getName() : "".concat(this.activeMatchForGame.getName(), " - ").concat(dayjs(this.activeMatchForGame.matchDate()).format('LL')) : 'Seleccionar un partido...';
    return m("div", {
      style: {
        marginBottom: '30px'
      }
    }, m(Button, {
      className: "Button match-selector-trigger ".concat(colorClass),
      onclick: () => app.modal.show(SelectMatchModal, {
        matches,
        onSelect: match => this.selectMatch(match)
      }),
      style: {
        width: '100%',
        padding: '14px 20px',
        borderRadius: '12px',
        fontWeight: 'bold',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        background: 'rgba(255, 255, 255, 0.05)',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        color: 'var(--text-color)',
        textAlign: 'left',
        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
        cursor: 'pointer',
        transition: 'background 0.2s, border-color 0.2s',
        height: 'auto',
        overflow: 'hidden'
      }
    }, m("span", {
      style: {
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        maxWidth: 'calc(100% - 20px)'
      }
    }, m("i", {
      className: "fas fa-search",
      style: {
        color: 'var(--muted-color)',
        flexShrink: 0
      }
    }), m("span", {
      style: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
      }
    }, selectedMatchLabel)), m("i", {
      className: "fas fa-chevron-down",
      style: {
        color: 'var(--muted-color)',
        flexShrink: 0
      }
    })));
  }
  view() {
    if (this.loading) {
      return m("div", {
        className: "AurreraJokoakPage"
      }, m("div", {
        className: "container",
        style: "padding: 40px; text-align: center;"
      }, m(LoadingIndicator, null)));
    }
    const bolillaMatches = this.getBolillaMatches();
    const ratingMatches = this.getRatingMatches();
    const seasonParam = this.currentSeasonName.replace('/', '-');
    const isMobile = this.isMobile();
    const clubSlug = app.forum.attribute('nagusiMatchRatingsClubSlug') || 'athletic';
    const isReal = clubSlug === 'real-sociedad';
    const gorbeaUrl = isReal ? 'pastor-del-txindoki' : 'pastor-del-gorbea';
    const gorbeaLabel = isReal ? 'Pastor del Txindoki' : 'Pastor del Gorbea';
    return m("div", {
      className: "AurreraJokoakPage"
    }, m("div", {
      className: "container",
      style: "padding-top: 40px; padding-bottom: 60px;"
    }, m(NagusiBackNav, {
      title: "Aurrera Jokoak"
    }), m(JokoakNavbar, null), m("div", {
      className: "AurreraJokoak-header"
    }, m("h2", null, m("span", null, "Aurrera"), " Jokoak"), m("p", null, app.translator.trans('bizkaitarra-lineup.forum.aurrera_jokoak.description'))), m("div", {
      className: "AurreraJokoak-grid"
    }, m("div", {
      className: "AurreraJokoakCard ".concat(this.activeGame === 'bolilla' ? 'active-card' : '')
    }, m("div", null, m("div", {
      style: "font-size: 4rem; margin-bottom: 20px; line-height: 1; filter: drop-shadow(0 4px 8px rgba(0,0,0,0.1));"
    }, "\uD83D\uDD2E"), m("h3", null, app.translator.trans('bizkaitarra-lineup.forum.aurrera_jokoak.card_bolilla')), m("p", null, app.translator.trans('bizkaitarra-lineup.forum.aurrera_jokoak.card_bolilla_desc'))), m("div", {
      style: "display: flex; gap: 10px;"
    }, m(Link, {
      href: "/la-bolilla/".concat(seasonParam, "/votar"),
      className: "Button Button--primary"
    }, m("i", {
      className: "fas fa-vote-yea",
      style: "margin-right: 6px;"
    }), app.translator.trans('bizkaitarra-lineup.forum.aurrera_jokoak.btn_vote')), m(Link, {
      href: "/la-bolilla/".concat(seasonParam, "/clasificacion"),
      className: "Button Button--secondary"
    }, m("i", {
      className: "fas fa-trophy",
      style: "margin-right: 6px; color: #ffd700;"
    }), app.translator.trans('bizkaitarra-lineup.forum.aurrera_jokoak.btn_classification')))), this.activeGame === 'bolilla' && isMobile && m("div", {
      className: "AurreraJokoak-action-section"
    }, m("div", null, m("h3", {
      style: "font-size: 1.4em; font-weight: 800; margin: 0 0 20px 0; display: flex; align-items: center; gap: 10px;"
    }, m("i", {
      className: "fas fa-futbol",
      style: "color: #ff2523;"
    }), "Partidos disponibles para La Bolilla"), this.renderMatchSelector(bolillaMatches, String(app.translator.trans('bizkaitarra-lineup.forum.aurrera_jokoak.no_active_matches_bolilla')), 'selected-bolilla'), this.activeMatchForGame && m("div", {
      style: "border-top: 1px solid rgba(0,0,0,0.08); padding-top: 30px; animation: fadeIn 0.4s;"
    }, this.loadingMatchDetails ? m("div", {
      style: "text-align: center; padding: 20px;"
    }, m(LoadingIndicator, null)) : m(BolillaWidget, {
      match: this.activeMatchForGame,
      key: this.activeMatchForGame.id()
    })))), this.activeGame === 'lineup' && isMobile && m("div", {
      className: "AurreraJokoak-action-section"
    }, m("div", null, m("h3", {
      style: "font-size: 1.4em; font-weight: 800; margin: 0 0 20px 0; display: flex; align-items: center; gap: 10px;"
    }, m("i", {
      className: "fas fa-futbol",
      style: "color: #ff2523;"
    }), "Partidos disponibles para 11 Aldeanos"), this.renderMatchSelector(bolillaMatches, String(app.translator.trans('bizkaitarra-lineup.forum.aurrera_jokoak.no_active_matches_lineup')), 'selected-bolilla'), this.activeMatchForGame && m("div", {
      style: "border-top: 1px solid rgba(0,0,0,0.08); padding-top: 30px; animation: fadeIn 0.4s;"
    }, this.loadingMatchDetails ? m("div", {
      style: "text-align: center; padding: 20px;"
    }, m(LoadingIndicator, null)) : m(UserMatchLineupWidget, {
      match: this.activeMatchForGame,
      key: this.activeMatchForGame.id()
    })))), m("div", {
      className: "AurreraJokoakCard ".concat(this.activeGame === 'rating' ? 'active-card' : '')
    }, m("div", null, m("div", {
      style: "font-size: 4rem; margin-bottom: 20px; line-height: 1; filter: drop-shadow(0 4px 8px rgba(0,0,0,0.1));"
    }, "\uD83C\uDFC3\u200D\u2642\uFE0F"), m("h3", null, app.translator.trans('bizkaitarra-lineup.forum.aurrera_jokoak.card_rating')), m("p", null, app.translator.trans('bizkaitarra-lineup.forum.aurrera_jokoak.card_rating_desc'))), m("div", {
      style: "display: flex; gap: 10px;"
    }, m(Link, {
      href: "/valoracion-".concat(clubSlug, "/").concat(seasonParam, "/valorar"),
      className: "Button Button--primary"
    }, m("i", {
      className: "fas fa-star",
      style: "margin-right: 6px;"
    }), app.translator.trans('bizkaitarra-lineup.forum.aurrera_jokoak.btn_rate')), m(Link, {
      href: app.route('matchRatingsStats', {
        season: seasonParam
      }),
      className: "Button Button--secondary"
    }, m("i", {
      className: "fas fa-chart-line",
      style: "margin-right: 6px; color: #4caf50;"
    }), app.translator.trans('bizkaitarra-lineup.forum.aurrera_jokoak.btn_classification')))), this.activeGame === 'rating' && isMobile && m("div", {
      className: "AurreraJokoak-action-section"
    }, m("div", null, m("h3", {
      style: "font-size: 1.4em; font-weight: 800; margin: 0 0 20px 0; display: flex; align-items: center; gap: 10px;"
    }, m("i", {
      className: "fas fa-star",
      style: "color: #ffb300;"
    }), "Partidos disponibles para valoraciones"), this.renderMatchSelector(ratingMatches, String(app.translator.trans('bizkaitarra-lineup.forum.aurrera_jokoak.no_active_matches_rating')), 'selected-rating'), this.activeMatchForGame && m("div", {
      style: "border-top: 1px solid rgba(0,0,0,0.08); padding-top: 30px; animation: fadeIn 0.4s;"
    }, this.loadingMatchDetails ? m("div", {
      style: "text-align: center; padding: 20px;"
    }, m(LoadingIndicator, null)) : m(MatchRatingComponent, {
      match: this.activeMatchForGame,
      key: this.activeMatchForGame.id()
    })))), m("div", {
      className: "AurreraJokoakCard ".concat(this.activeGame === 'lineup' ? 'active-card' : '')
    }, m("div", null, m("div", {
      style: "font-size: 4rem; margin-bottom: 20px; line-height: 1; filter: drop-shadow(0 4px 8px rgba(0,0,0,0.1));"
    }, "\uD83C\uDFDF\uFE0F"), m("h3", null, app.translator.trans('bizkaitarra-lineup.forum.aurrera_jokoak.card_11aldeanos')), m("p", null, app.translator.trans('bizkaitarra-lineup.forum.aurrera_jokoak.card_11aldeanos_desc'))), m("div", {
      style: "display: flex; gap: 10px;"
    }, m(Link, {
      href: "/11-aldeanos/".concat(seasonParam, "/pronosticar"),
      className: "Button Button--primary"
    }, m("i", {
      className: "fas fa-futbol",
      style: "margin-right: 6px;"
    }), app.translator.trans('bizkaitarra-lineup.forum.aurrera_jokoak.btn_predict_lineup')), m(Link, {
      href: "/11-aldeanos/".concat(seasonParam, "/clasificacion"),
      className: "Button Button--secondary",
      style: "display: inline-flex; align-items: center;"
    }, m("i", {
      className: "fas fa-list-ol",
      style: "margin-right: 6px;"
    }), app.translator.trans('bizkaitarra-lineup.forum.aurrera_jokoak.btn_classification')))), m("div", {
      className: "AurreraJokoakCard"
    }, m("div", null, m("div", {
      style: "font-size: 4rem; margin-bottom: 20px; line-height: 1; filter: drop-shadow(0 4px 8px rgba(0,0,0,0.1));"
    }, "\u26F0\uFE0F"), m("h3", null, gorbeaLabel), m("p", null, "Pronostica la clasificaci\xF3n de Primera Divisi\xF3n, m\xE1ximos goleadores/asistentes y Copa de toda la temporada.")), m("div", {
      style: "display: flex; gap: 10px;"
    }, m(Link, {
      href: "/".concat(gorbeaUrl, "/").concat(seasonParam, "/votar"),
      className: "Button Button--primary",
      style: "display: inline-flex; align-items: center;"
    }, m("i", {
      className: "fas fa-vote-yea",
      style: "margin-right: 6px;"
    }), app.translator.trans('bizkaitarra-lineup.forum.aurrera_jokoak.btn_vote')), m(Link, {
      href: "/".concat(gorbeaUrl, "/").concat(seasonParam, "/clasificacion"),
      className: "Button Button--secondary",
      style: "display: inline-flex; align-items: center;"
    }, m("i", {
      className: "fas fa-trophy",
      style: "margin-right: 6px; color: #ffd700;"
    }), app.translator.trans('bizkaitarra-lineup.forum.aurrera_jokoak.btn_classification')))), m("div", {
      className: "AurreraJokoakCard"
    }, m("div", null, m("div", {
      style: "font-size: 4rem; margin-bottom: 20px; line-height: 1; filter: drop-shadow(0 4px 8px rgba(0,0,0,0.1));"
    }, "\uD83C\uDF0D"), m("h3", null, app.translator.trans('nagusi-match-ratings.forum.mundial.porrita_title')), m("p", null, "Consulta la clasificaci\xF3n final y la porrita del Mundial 2026.")), m("div", {
      style: "display: flex; gap: 10px;"
    }, m(Link, {
      href: "/mundial-2026/clasificacion",
      className: "Button Button--secondary",
      style: "display: inline-flex; align-items: center;"
    }, m("i", {
      className: "fas fa-trophy",
      style: "margin-right: 6px; color: #ffd700;"
    }), app.translator.trans('bizkaitarra-lineup.forum.aurrera_jokoak.btn_classification'))))), this.activeGame !== 'none' && !isMobile && m("div", {
      className: "AurreraJokoak-action-section",
      style: "margin-top: 30px;"
    }, this.activeGame === 'bolilla' && m("div", null, m("h3", {
      style: "font-size: 1.4em; font-weight: 800; margin: 0 0 20px 0; display: flex; align-items: center; gap: 10px;"
    }, m("i", {
      className: "fas fa-futbol",
      style: "color: #ff2523;"
    }), "Partidos disponibles para La Bolilla"), this.renderMatchSelector(bolillaMatches, String(app.translator.trans('bizkaitarra-lineup.forum.aurrera_jokoak.no_active_matches_bolilla')), 'selected-bolilla'), this.activeMatchForGame && m("div", {
      style: "border-top: 1px solid rgba(0,0,0,0.08); padding-top: 30px; animation: fadeIn 0.4s;"
    }, this.loadingMatchDetails ? m("div", {
      style: "text-align: center; padding: 20px;"
    }, m(LoadingIndicator, null)) : m(BolillaWidget, {
      match: this.activeMatchForGame,
      key: this.activeMatchForGame.id()
    }))), this.activeGame === 'rating' && m("div", null, m("h3", {
      style: "font-size: 1.4em; font-weight: 800; margin: 0 0 20px 0; display: flex; align-items: center; gap: 10px;"
    }, m("i", {
      className: "fas fa-star",
      style: "color: #ffb300;"
    }), "Partidos disponibles para valoraciones"), this.renderMatchSelector(ratingMatches, String(app.translator.trans('bizkaitarra-lineup.forum.aurrera_jokoak.no_active_matches_rating')), 'selected-rating'), this.activeMatchForGame && m("div", {
      style: "border-top: 1px solid rgba(0,0,0,0.08); padding-top: 30px; animation: fadeIn 0.4s;"
    }, this.loadingMatchDetails ? m("div", {
      style: "text-align: center; padding: 20px;"
    }, m(LoadingIndicator, null)) : m(MatchRatingComponent, {
      match: this.activeMatchForGame,
      key: this.activeMatchForGame.id()
    }))), this.activeGame === 'lineup' && m("div", null, m("h3", {
      style: "font-size: 1.4em; font-weight: 800; margin: 0 0 20px 0; display: flex; align-items: center; gap: 10px;"
    }, m("i", {
      className: "fas fa-futbol",
      style: "color: #ff2523;"
    }), "Partidos disponibles para 11 Aldeanos"), this.renderMatchSelector(bolillaMatches, String(app.translator.trans('bizkaitarra-lineup.forum.aurrera_jokoak.no_active_matches_lineup')), 'selected-bolilla'), this.activeMatchForGame && m("div", {
      style: "border-top: 1px solid rgba(0,0,0,0.08); padding-top: 30px; animation: fadeIn 0.4s;"
    }, this.loadingMatchDetails ? m("div", {
      style: "text-align: center; padding: 20px;"
    }, m(LoadingIndicator, null)) : m(UserMatchLineupWidget, {
      match: this.activeMatchForGame,
      key: this.activeMatchForGame.id()
    }))))));
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/aurrera-jokoak/AurreraJokoakPage', AurreraJokoakPage);